module.exports = __webpack_public_path__ + "static/Atlanterhavsveien_hovedside1-ae3746bf3265086662a8138b44853475.png";